var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('div',{staticClass:"space-bottom"},[_vm._v("RECONOCIDOS POR LOS PRINCIPALES MEDIOS")]),_c('div',{staticClass:"logos"},_vm._l((_vm.logos),function(logo){return _c('figure',{key:logo.src,staticClass:"logo"},[_c('img',{attrs:{"src":logo.src}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }